import { render } from "./WhatsAppMetaPhoneActivationDialog.vue?vue&type=template&id=a727fa20&ts=true"
import script from "./WhatsAppMetaPhoneActivationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppMetaPhoneActivationDialog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/components/WhatsAppMetaPhoneActivationDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a727fa20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a727fa20', __exports__)) {
    api.reload('a727fa20', __exports__)
  }
  
  module.hot.accept("./WhatsAppMetaPhoneActivationDialog.vue?vue&type=template&id=a727fa20&ts=true", () => {
    api.rerender('a727fa20', render)
  })

}


export default __exports__